module.exports = __webpack_public_path__ + "app/principal/billing-address/billing-address-cez_YvOL.html";